import styled, { css } from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { Flex, Row } from 'Components/UI/_Legacy'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled(Flex)
  .attrs({
    width: 1,
    justifyContent: 'center',
    alignItems: 'center',
    mt: [32, 32, 100, 136],
  })
  .withConfig({ shouldForwardProp })`
  position: relative;
  color: ${themeGet('colors.white')};
`

export const Content = styled(Flex)
  .attrs({
    alignItems: ['center', 'center', 'center', 'flex-start'],
    width: 1,
  })
  .withConfig({ shouldForwardProp })`
  background-color: ${themeGet('colors.white')};
`

export const Description = styled(Flex)
  .attrs({
    width: 1,
  })
  .withConfig({ shouldForwardProp })`
  flex-direction: column;
  align-items: flex-start;
  background-color: ${themeGet('colors.white')};
`

export const ImageWrapper = styled(Row)`
  max-width: 524px;
  width: 100%;
  position: relative;
`

export const PrimaryImageHolder = styled(Row)`
  width: 100%;
  padding-top: 94%;
  overflow: hidden;
  position: relative;
  border-radius: 40px;
  background-color: ${themeGet('colors.white')};
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05);

  div:first-child {
    position: absolute !important;
    top: 0;
    left: -2px;
    right: 0;
    bottom: 0;
  }

  img {
    width: 100%;
    object-fit: cover;
  }
`

const primaryImageBgReverse = ({ reverse }) =>
  reverse &&
  css`
    right: unset;
    left: -40px;

    @media screen and (max-width: ${themeGet('breakpoints.0')}) {
      right: unset;
      left: -20px;
    }
  `

export const PrimaryImageBg = styled.div`
  width: 100%;
  height: 100%;
  max-width: 447px;
  position: absolute;
  top: -40px;
  right: -40px;
  background-color: #f8f5f6;
  border-radius: 80px;

  @media screen and (max-width: ${themeGet('breakpoints.0')}) {
    top: -20px;
    right: -20px;
    border-radius: 40px;
  }

  ${primaryImageBgReverse};
`

export const SecondaryImageHolder = styled(Row).attrs({
  pt: ['56.25%', '40.91%'],
})`
  width: 100%;
  overflow: hidden;
  position: relative;
  border-radius: 24px;

  background-color: tomato;

  div:first-child {
    position: absolute !important;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    max-width: 100% !important;
  }

  img {
    width: 100%;
    object-fit: cover;
  }
`
